/*
 * Story-Bubbles (snippets/ll-category-stories.liquid): Wie bei Instagram bekommen bereits besuchte Kategorien einen
 * grauen Ring. Gemerkt wird nur im Browser des Besuchers (localStorage). Ist der Speicher gesperrt (privates Fenster),
 * bleiben einfach alle Ringe farbig.
 */
const KEY = "ll-stories-seen";
const MAX = 200;

const readSeen = () => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

const writeSeen = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(-MAX)));
  } catch {
    // Speicher nicht verfuegbar - ohne Merken weiter
  }
};

// Die aktuelle Collection zaehlt als gesehen (z. B. Rueckweg ueber die Eltern-Collection)
const current = location.pathname.match(/\/collections\/([^/?#]+)/)?.[1];
const seen = readSeen();
if (current && !seen.includes(current)) {
  seen.push(current);
  writeSeen(seen);
}

document.querySelectorAll("[data-ll-story]").forEach((link) => {
  const handle = link.getAttribute("data-ll-story");
  link.classList.toggle("is-seen", seen.includes(handle));
  link.addEventListener("click", () => {
    const list = readSeen();
    if (!list.includes(handle)) {
      list.push(handle);
      writeSeen(list);
    }
  });
});

// Story-Bubbles "Deal" (.ll-st): aktive Collection beim Laden ins Bild scrollen (nur horizontal, kein Seiten-Scroll)
document.querySelectorAll(".ll-st").forEach((nav) => {
  const current = nav.querySelector("[aria-current]");
  if (current && current.offsetLeft + current.offsetWidth > nav.clientWidth) {
    nav.scrollLeft = current.offsetLeft - 24;
  }
});
